module.exports = [{"name":"Business Associate Agreement (BAA)","papers":[{"title":"Business Associate Agreement (BAA)","id":"auth0-baa","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg","date":"October, 2017","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/Auth0-BAA.pdf"},{"action":"open","file":"https://cdn.auth0.com/website/legal/files/Auth0-BAA.pdf"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/baa/data/baaPapers.json
// module id = 1641
// module chunks = 0